import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["source"];

    copy() {
        const textToCopy = this.sourceTarget.value;
        const textArea = document.createElement("textarea");
        textArea.value = textToCopy;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);

        this.sourceTarget.classList.add("notam-flash-effect");
        setTimeout(() => {
            this.sourceTarget.classList.remove("notam-flash-effect");
        }, 200);
    }
}
